import { UnleashClient } from "unleash-proxy-client";

import { environment, featureProxyClientId, featureProxyUrl } from "@/environment";

export let featureToggles = dummyToggles();

export async function initFeatureToggles(userId) {
  if (featureProxyUrl && featureProxyClientId) {
    const unleash = unleashToggles();
    await unleash.updateContext({ userId });
    await unleash.start();
    featureToggles = unleash;
  }
}

function unleashToggles() {
  return new UnleashClient({
    url: featureProxyUrl,
    clientKey: featureProxyClientId,
    appName: environment,
    refreshInterval: 60 * 60 * 12, // update toggles after 12h
    disableMetrics: true,
  });
}

function dummyToggles() {
  return {
    isEnabled() {
      return false;
    },
  };
}
